import React from 'react';
import { func, node, string } from 'prop-types';
import Modal from '../Modal';


const MessageModal = (props) => {

  return (

    <Modal
      size="md"
      title={props.title}
      header={<span className="modal-icon material-symbols-outlined ms-auto">error</span>}
      onEscape={() => props.onDismiss()}
      focusPrimary
      body={<p>{props.message}</p>}
      footer={!props.disabled ? (<>
              <button className="btn btn-outline-primary" data-dismiss="modal" onClick={ (event) => props.onDismiss() }>{props.cancelLabel}</button>
              <button className="btn btn-primary" data-dismiss="modal" onClick={ (event) => props.onConfirm() }>{props.confirmLabel}</button>
      </>) : (
              <button className="btn back-button" data-dismiss="modal" onClick={ (event) => props.onDismiss() }>Volver</button>
      )}
      footerClassName={props.disabled ? 'f-align' : ''}
    />

  );
}

MessageModal.propTypes = {
  onConfirm: func.isRequired,
  onDismiss: func.isRequired,
  message: node,
  title: string,
  icon: string,
  confirmLabel: string,
  cancelLabel: string
};

MessageModal.defaultProps = {
  message: "",
  title: "",
  icon: "",
  confirmLabel: "Aceptar",
  cancelLabel: "Cancelar"
};

export default MessageModal;
